import {Box, Button} from '@mui/material';
import {Link} from 'react-router-dom';

const NavCrmButton = ({
  svg,
  label,
  navigateUrl,
  isExternalLink,
  closeNavHandler,
}) => {
  const button = (
    <Button
      onClick={closeNavHandler}
      disableRipple
      sx={{
        borderRadius: '50%',
        minWidth: '40px',
        height: '40px',
        background: '#F5F5F5 !important',
        padding: 0,
        border: '1px solid #FFFFFF',
        boxShadow: '-2px -2px 7px #FFF,1px 1px 10px rgba(0, 0, 0, 0.10)',
      }}>
      <img src={svg} alt='' />
    </Button>
  );

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        paddingTop: '8px',
        mb: '16px',
      }}>
      {isExternalLink ? (
        <a href={navigateUrl} rel='noreferrer'>
          {button}
        </a>
      ) : (
        <Link to={navigateUrl}>{button}</Link>
      )}
      <span
        style={{
          fontSize: '12px',
          color: '#707070',
          fontWeight: 700,
          marginRight: '10px',
        }}>
        {label}
      </span>
    </Box>
  );
};

export default NavCrmButton;
